/*
 * @Author: LiZhiWei
 * @Date: 2026-01-27 09:28:58
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-29 16:14:33
 * @Description:
 */
export interface CaseSummary {
  id: string | number
  title: string
  cover: string
  tags: string[]
  logo?: string
}

export const caseSummaries: CaseSummary[] = [
  {
    id: 1,
    title: '西溪里',
    cover: '/images/case-studies/xxl.jpg',
    tags: ['住宅', '海南 海口'],
    logo: 'i-custom-syht', // Placeholder, assuming assets exist or will be handled
  },
  {
    id: 2,
    title: '长岛蓝湾',
    cover: '/images/case-studies/cdlw.jpg',
    tags: ['住宅', '海南 临高'],
    logo: 'i-custom-syht',
  },
  {
    id: 3,
    title: '蓝岛康城',
    cover: '/images/case-studies/ldkc.jpg',
    tags: ['住宅', '海南 海口'],
    logo: 'i-custom-zhc',
  },
  {
    id: 4,
    title: '普罗旺世',
    cover: '/images/case-studies/plws.jpg',
    tags: ['住宅', '河南 郑州'],
    logo: 'i-custom-zjwy',
  },
  {
    id: 5,
    title: '名门广场购物中心',
    cover: '/images/case-studies/mmggggzx.jpg',
    tags: ['商业', '海南 海口'],
    logo: '',
  },
  {
    id: 6,
    title: '滨濂国际-商业',
    cover: '/images/case-studies/blgj-sy.jpg',
    tags: ['综合体', '海南 海口'],
    logo: '',
  },
  {
    id: 7,
    title: '晋园·海棠湾',
    cover: '/images/case-studies/jy·htw.jpg',
    tags: ['住宅', '海南 三亚'],
    logo: 'i-custom-jhwy',
  },
  {
    id: 8,
    title: '中交·药谷雅郡',
    cover: '/images/case-studies/zz·ygyj.jpg',
    tags: ['住宅', '海南 海口'],
    logo: '',
  },
  {
    id: 9,
    title: '海垦·金湖壹号',
    cover: '/images/case-studies/hk·jhyh.jpg',
    tags: ['住宅', '海南 海口'],
    logo: 'i-custom-zhc',
  },
  {
    id: 10,
    title: '三亚中心渔港',
    cover: '/images/case-studies/syzxyg.jpg',
    tags: ['住宅', '海南 三亚'],
    logo: '',
  },
  {
    id: 11,
    title: '湖南和安家园',
    cover: '/images/case-studies/hnhajy.jpg',
    tags: ['住宅', '湖南 怀化'],
    logo: '',
  },
  {
    id: 12,
    title: '古田干部学院',
    cover: '/images/case-studies/gtgbxy.jpg',
    tags: ['学校', '福建 龙岩'],
    logo: '',
  },
  {
    id: 13,
    title: '怡和·湖城大境',
    cover: '/images/case-studies/yh·hcdj.jpg',
    tags: ['住宅', '海南 海口'],
    logo: '',
  },
  {
    id: 14,
    title: '宝安·山水龙城',
    cover: '/images/case-studies/ba·sslc.jpg',
    tags: ['住宅', '海南 儋州'],
    logo: '',
  },
  {
    id: 15,
    title: '友谊·南海城',
    cover: '/images/case-studies/yy·nhc.jpg',
    tags: ['商业', '海南 海口'],
    logo: 'i-custom-zcsy',
  },
  {
    id: 16,
    title: '雄翔·富安居',
    cover: '/images/case-studies/xx·faj.jpg',
    tags: ['住宅', '广西 玉林'],
    logo: '',
  },
  {
    id: 17,
    title: '中华坊',
    cover: '/images/case-studies/zhh.jpg',
    tags: ['住宅', '海南 澄迈'],
    logo: '',
  },
  {
    id: 18,
    title: '龙岩会展中心',
    cover: '/images/case-studies/lyhzzx.jpg',
    tags: ['公共', '福建 龙岩'],
    logo: '',
  },
  {
    id: 19,
    title: '观澜湖·九里',
    cover: '/images/case-studies/glh·jl.jpg',
    tags: ['住宅', '海南 海口'],
    logo: '',
  },
  {
    id: 20,
    title: '置地花园',
    cover: '/images/case-studies/zdhy.jpg',
    tags: ['住宅', '海南 海口'],
    logo: '',
  },
  {
    id: 21,
    title: '龙岩洞文创园',
    cover: '/images/case-studies/lydwcy.jpg',
    tags: ['园区', '福建 龙岩'],
    logo: '',
  },
  {
    id: 22,
    title: '璞域玖棠府',
    cover: '/images/case-studies/pyjtf.jpg',
    tags: ['住宅', '海南 海口'],
    logo: '',
  },
  {
    id: 23,
    title: '品润滨江郡',
    cover: '/images/case-studies/prbjj.jpg',
    tags: ['住宅', '福建 福州'],
    logo: '',
  },
  {
    id: 24,
    title: '龙珠新城',
    cover: '/images/case-studies/lzxc.jpg',
    tags: ['住宅', '海南 海口'],
    logo: 'i-custom-zjwy',
  },
]
